import React, {Component} from "react";
import {Link, withRouter} from "react-router-dom";
import {Breadcrumb, DatePicker, Icon, List, Tooltip} from "antd";
import {projectStatusCodeMap} from "../../../../components/ProjectStatusCodeMap";
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import {Col, Grid, Row} from "react-flexbox-grid";
import {spinnerOff, spinnerOn} from "../../../../components/Spinner";
import {
    getPreEFormException,
    getApprovalsPage,
    restartApprovalProcess,
    requestApprover,
    cancelApprover, approverProcess
} from "../../../../api/PreEForm";
import Button from "../../../../components/Button";
import Form from 'react-bootstrap/Form';
import RequestDialog from "../../../../components/PreEApprovals/RequestDialog";
import RestartDialog from "../../../../components/PreEApprovals/RestartDialog";
import ApproveDialog from "../../../../components/PreEApprovals/ApproveDialog";
import DenyDialog from "../../../../components/PreEApprovals/DenyDialog";
import CancelDialog from "../../../../components/PreEApprovals/CancelDialog";
import {
    isCreatorOrAdministratorOrInternalContributor, isExternalContributor
} from "../../../../utils/UserInfo";
import {confirmAlert} from "react-confirm-alert";
import moment from "moment-timezone";
import Alert from "../../../../components/Alert";
import workflowdiagram from "./Energization_Exception_Approval_Workflow.jpg";
import workFlowImage from "./Flow_Icon.png"
import {preExceptionStatusCodeMap} from "../../../../components/PreEApprovals/PreExceptionStatusCodeMap";
import {preApprovalStatusCodeMap} from "../../../../components/PreEApprovals/PreApprovalStatusCodeMap";
import IPSLocationAssetCollapse from "containers/PreEForm/PreEFormFields/IPSLocations/IPSLocationAssetCollapse";

const roleStyle = {
    height: "58px",
    overflow: "auto"
}
class PreEApprovals extends Component {

    state = {
        preEFormExceptions: this.props.preEFormExceptions,
        project: this.props.project,
        approvalsResponse : {},
        requestSignRequest : {},
        approver: {},
    }
    constructor(props) {
        super(props);
        this.onChangeApprover = this.onChangeApprover.bind(this);
    }

    async componentDidMount() {
        this.getApproversList();
    }

    async getApproversList(){
        spinnerOn();
        let approvalsResponse = await getApprovalsPage(this.props.match.params.formId,this.props.match.params.exceptionId);
       
        this.setState({ approvalsResponse });
        this.setState({situationText: approvalsResponse.exception.situation});
        this.setState({timelineText: approvalsResponse.exception.timeline});
        this.setState({preEnergizationDateText: moment(approvalsResponse?.preForm?.preEnergizationDate).format('MM/DD/YYYY')});
        this.setState({primaryContactText: approvalsResponse.exception.primaryContactName});
        this.setState({tdccoordinators: approvalsResponse.exception.tdccoordinators});
        this.setState({exceptionTitle: approvalsResponse.exception.title});
        this.setState({approvalResponseDateText: moment(approvalsResponse.exception.approvalResponseDate).format('MM/DD/YYYY')});
        this.setState({formName: approvalsResponse.preForm.formName});
        this.setState({formStatus: approvalsResponse.preForm.energizationStatusDesc});
        this.setState({reqSos: approvalsResponse.preForm.reqSos});
        this.setState({protectionSystem: approvalsResponse.exception.protectionSystem});
        this.setState({ddcsystem: approvalsResponse.exception.ddcsystem});
        this.setState({resolutionDate: moment(approvalsResponse.exception.resolutionDate).format('MM/DD/YYYY')});
        this.setState({closed: approvalsResponse.exception.closed});
        this.setState({statusCode: approvalsResponse.exception.statusCode});
        this.setState({exceptionStatus: approvalsResponse.exception.status});
        this.setState({exceptionStatusChangedBy: approvalsResponse.exception.exceptionStatusChangedBy});
        let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.setState({exceptionStatusChangedDate: approvalsResponse.exception.exceptionStatusChangedDate ?
                moment(approvalsResponse.exception.exceptionStatusChangedDate).tz(userTimeZone).format('MM/DD/YYYY h:mm a z') : null});
        spinnerOff();
    }

    render() {
        const {project, approvalsResponse, situationText, timelineText,preEnergizationDateText,primaryContactText,tdccoordinators,approvalResponseDateText,
            exceptionTitle, formName, formStatus, reqSos, protectionSystem, ddcsystem, resolutionDate, closed, statusCode, exceptionStatus,
            exceptionStatusChangedBy, exceptionStatusChangedDate} = this.state;
        const {status} = this.props;
        const formId = this.props.match.params.formId;
        const statusStr = exceptionStatus===preExceptionStatusCodeMap["WAITING"] ? ('Requested By ' + exceptionStatusChangedBy + ' on ' + exceptionStatusChangedDate)
            : exceptionStatus===preExceptionStatusCodeMap["CANCELLED"] ? ('Cancelled By ' + exceptionStatusChangedBy + ' on ' + exceptionStatusChangedDate)
            : (exceptionStatus===preExceptionStatusCodeMap["PENDING"] && exceptionStatusChangedDate != null) ? ('Restarted By ' + exceptionStatusChangedBy + ' on ' + exceptionStatusChangedDate) : '';

        return (
        <>
            <Row>
                <Col md={4} xs={12}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link to={`/${status}/${project.id}/peform/${formId}/exceptions`} onClick={()=>this.props.updateExceptionsState(formId)}>Pre E Exception List</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            {exceptionTitle}
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col lg={6} md={6} xs={12}>
                    <Row>
                        <Col lg={5} md={3} xs={6}><strong> Pre-Energization Form: </strong></Col>
                        <Col lg={7} md={5} xs={6}>{formName}</Col>
                    </Row>
                    <Row>
                        <Col lg={5} md={3} xs={6}><strong> Energization Date: </strong></Col>
                        <Col lg={7} md={5} xs={6}>{preEnergizationDateText}</Col>
                    </Row>
                    <Row>
                        <Col lg={5} md={3} xs={6}><strong> Energization Status: </strong></Col>
                        <Col lg={7} md={5} xs={6}>{formStatus}</Col>
                    </Row>
                    <Row>
                        <Col lg={5} md={3} xs={6}><strong> REQ/SOS#: </strong></Col>
                        <Col lg={7} md={2} xs={6}>{reqSos}</Col>
                    </Row>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col lg={6} md={6} xs={6}>
                    <Row>
                        <Col lg={5} md={2} xs={6}><strong> Exception Title: </strong></Col>
                        <Col lg={7} md={2} xs={6}>{exceptionTitle}</Col>
                    </Row>
                    <Row>
                        <Col lg={5} md={2} xs={6}><strong> Protection System: </strong></Col>
                        <Col lg={7} md={2} xs={6}>{protectionSystem==='Y' ? 'Yes' : 'No'}</Col>
                    </Row>
                    <Row>
                        <Col lg={5} md={2} xs={6}><strong> DDC Equipment: </strong></Col>
                        <Col lg={7} md={2} xs={6}>{ddcsystem==='Y' ? 'Yes' : 'No'}</Col>
                    </Row>
                    <Row>
                        <Col lg={5} md={2} xs={6}><strong> Expected Resolution Date: </strong></Col>
                        <Col lg={7} md={2} xs={6}>{resolutionDate}</Col>
                    </Row>
                    <Row>
                        <Col lg={5} md={2} xs={6}><strong> Exception Status: </strong></Col>
                        <Col lg={7} md={2} xs={6}>{closed==='Y' ? 'Closed' : 'Open'}</Col>
                    </Row>
                    <br/>
                </Col>

                <Col lg={6} md={6} xs={6} style={{textAlign: 'right'}}>
                    <Row>
                        <Col lg={5} md={4} xs={2}><strong> Primary Contact: </strong></Col>
                        <Col lg={7} md={4} xs={4} style={{textAlign: 'left'}}>{primaryContactText}</Col>
                    </Row>
                    <Row>
                        <Col lg={5} md={4} xs={2}><strong> TDC Coord: </strong></Col>
                        <Col lg={7} md={4} xs={4} style={{textAlign: 'left'}}>{tdccoordinators}</Col>
                    </Row>
                    <Row>
                        <Col lg={5} md={4} xs={2}><strong> Approval Status: </strong></Col>
                        <Col lg={7} md={4} xs={4} style={{textAlign: 'left'}}>{statusCode}</Col>
                    </Row>
                    <Row>
                        <Col lg={5} md={4} xs={2} style={{padding: '1px'}}><div rows="2"><strong> Response Needed By: </strong></div></Col>
                        <Col lg={7} md={4} xs={4} style={{textAlign: 'left'}}><div rows="2">{approvalResponseDateText}</div></Col>
                    </Row>
                    <br/>
                </Col>
            </Row>
            <Row>
                <Col lg={7} md={4} xs={6}>
                    <Row>
                        <Col lg={2} md={2} xs={6}><strong> Situation: </strong></Col>
                        <Col lg={10} md={6} xs={6}>
                            <Form.Control as="textarea" id= "situation" rows="2" style={{maxWidth: "98%"}} value={situationText} maxLength="2400"
                                          disabled/>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col lg={2} md={2} xs={6}><strong> Timeline: </strong></Col>
                        <Col lg={10} md={6} xs={6}>
                            <Form.Control as="textarea" id= "timeline" rows="2" style={{maxWidth: "98%"}} value={timelineText} maxLength="2400"
                                          disabled/>
                        </Col>
                    </Row>
                </Col>
                <Col lg={5} md={4} xs={6} style={{textAlign: 'left'}}>
                    {(this.props.project.projectStatus !== projectStatusCodeMap["CLOSED"]) &&
                    <Row>
                        <Col lg={6} md={6} xs={6} style={{alignItems:'left'}}>
                            {(approvalsResponse.requestBtn === true) &&
                            <Button id={'requestButton'} onClickHandler={() => this.openRequestDialog()}>REQUEST</Button>}
                            {(approvalsResponse.cancelBtn === true) &&
                            <Button style={{ marginLeft: 8, align:'left'}} id={'cancelButton'} onClickHandler={() => this.openCancelDialog()}>CANCEL</Button>}
                            {(approvalsResponse.restartBtn === true) &&
                            <Button id={'restartButton'} style={{ marginLeft: 8, align:'left'}} onClickHandler={() => this.openRestartDialog()}>RESTART</Button>}
                        </Col>
                    </Row>
                    }
                    <br/>
                    <Row>
                        <Col lg={12} md={12} xs={12} style={{alignItems:'left'}}>
                            <div style={{alignItems: 'left'}}>{statusStr}</div>
                            {!approvalsResponse.statusHistory ? null : approvalsResponse.statusHistory.length>0 &&
                                this.getStatusHistory(approvalsResponse.statusHistory, statusStr)}
                        </Col>
                    </Row>
                </Col>
            </Row>
            {approvalsResponse.preFormExceptionMappings && approvalsResponse.preFormExceptionMappings.length>0 &&
            <Row style={{marginTop:24}}>
                <Col lg={1} md={2} xs={6} style={{marginRight: 16}} >
                    <strong>Assets:</strong>
                </Col>
                <Col lg={10} md={6} xs={6}>
                    <IPSLocationAssetCollapse
                        preEFormMappings={approvalsResponse.preFormExceptionMappings}
                        checkBoxHidden={true}
                        />
                </Col>
            </Row>
            }
            <Row style={{alignContent:'middle'}}>
                <Col xs={11} md={11} xs={11} style={{padding: '15px'}}>
                    <i class="fa fa-info-circle" style={{ color:'red',paddingRight:'3px' }} aria-hidden="true"></i><i>
                    Note: Approval must be received from each Approver Role below, one at a time, in the order below based on the details on the Exception Form.
                    If more than one Team Member is in the Approver Role, only one must respond to move to the next row. To re-send the Approval Request email, click
                        "Request" again.</i>
               </Col>
                <Col xs={1} md={1} xs={1} style={{marginTop:'20px'}}>
                    <div onMouseOver={()=>this.showApprovalFlowDiagram()}><img src={workFlowImage} alt="workflow-image"/></div>
                </Col>
            </Row>
            <div className="row" style={{padding:"1.5rem"}}>
                <div className="table-responsive">
                    <table className="table table-striped" >
                        <thead>
                        <tr>
                            <th>Role </th>
                            <th>User Name</th>
                            <th>E-mail</th>
                            <th>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            !approvalsResponse.approverRecords ? null : approvalsResponse.approverRecords.length>0 &&
                                this.ApprovalFormater(approvalsResponse.approverRecords, approvalsResponse.nextApproveRoleId, approvalsResponse.approveDenyBtn)
                        }
                        </tbody>
                    </table>
                </div>
            </div>
    </>
    );
    }

    getStatusHistory(statusHistory, statusStr)
    {
        let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if(statusHistory.length < 3)
        {
            return  statusHistory.map(record => (
                <div>{record.status}{' By '}{record.lastModifiedName}{' on '}{moment(record.lastUpdateDate).tz(userTimeZone).format('MM/DD/YYYY h:mm a z')}</div>
            ))
        }
        else if(statusHistory.length > 2) {
            let history1 = statusHistory[0];
            let history2 = statusHistory[1];
            return (
                <>
                    <div style={{alignItems: 'left'}}>{history1.status}{' By '}{history1.lastModifiedName}{' on '}{moment(history1.lastUpdateDate).tz(userTimeZone).format('MM/DD/YYYY h:mm a z')}</div>
                    <div style={{alignItems: 'left'}} className='line1'>
                        {history2.status}{' By '}{history2.lastModifiedName}{' on '}{moment(history2.lastUpdateDate).tz(userTimeZone).format('MM/DD/YYYY h:mm a z')}{'...'}</div>
                    <div className='tooltip' style={{width:"90%", alignItems: 'left'}}>
                        <div>{statusStr}</div>
                        {statusHistory.map(record => (
                            <div>{record.status}{' By '}{record.lastModifiedName}{' on '}{moment(record.lastUpdateDate).tz(userTimeZone).format('MM/DD/YYYY h:mm a z')}</div>
                        ))}
                    </div>
                </>
            )
        }
    }

    ApprovalFormater(approverRecords, nextApproveRoleId, approveDenyBtn)
    {
        return approverRecords.map(record => (
            <tr>
                <td style={{verticalAlign: 'middle'}}> {record.roleName} </td>
                <td> {this.ApproverNameFormatter(record.approvers)} </td>
                <td> {this.ApproverEmailFormatter(record.approvers)} </td>
                <td style={{verticalAlign: 'middle'}}> {this.ApprovalStatus(record, nextApproveRoleId, approveDenyBtn)}</td>
            </tr>
        ))
    }
    ApproverNameFormatter(approvers){
        return !approvers ? '' :approvers.map(approver => (
            <div>{approver.approverName}</div>))
    }

    ApproverEmailFormatter(approvers){
        return !approvers ? '' :approvers.map(approver => (
            <div>{approver.emailAddress?approver.emailAddress:' '}</div>))
    }

    ApprovalStatus(record, nextApproveRoleId, approveDenyBtn) {
        return (nextApproveRoleId != null && nextApproveRoleId==record.roleId  && approveDenyBtn === true) ?
            <div>
                <Button id={'acceptButton'} onClickHandler={() => this.openApproveDialog()} style={{width: '100px'}}>APPROVE</Button>
                <span>{'  '}</span>
                <Button id={'denyButton'} onClickHandler={() => this.openDenyDialog()} style={{width: '100px'}}>DENY</Button>
            </div>
            :
            (record.statusId ?  record.statusCode + ' By ' + record.approvedBy + ' on ' + record.approvedDate : '' )
    }

    onChangeApprover(approverId){
        const {approvalsResponse} = this.state;
        let updatedApprovers = approvalsResponse.approvers.map(approver => {
            let updatedApprover = {...approver};
            if ((approvalsResponse && approvalsResponse.approvers && approver.approverId === approverId)) {
                updatedApprover = {
                    ...updatedApprover,
                    ...{selected: !approver.selected}
                };
            }
            return updatedApprover;
        });
        let updatedApprovalsResponse = {...approvalsResponse};
        updatedApprovalsResponse.approvers = updatedApprovers;
        this.setState({
            approvalsResponse: updatedApprovalsResponse
        })
    }

    openRestartDialog(){
        const { approvalsResponse } = this.state;
        const options = {
                customUI: ({ onClose, ...props   }) =>
            <RestartDialog
        {...props}
        onClose={onClose}
        onAccept={() => this.restartSign(approvalsResponse.exceptionId, onClose)}
        />

    };
        confirmAlert(options)
    }

    openRequestDialog(){
        const { approvalsResponse } = this.state;
        let message = null;
        if (approvalsResponse.exception.status === preExceptionStatusCodeMap["PENDING"]){
            message = 'Are you sure? Click yes to start the Approval Workflow by sending the Approval Request Email to the next Approver.';
        }
        else if(approvalsResponse.exception.status == preExceptionStatusCodeMap["WAITING"]){
            message = 'Are you sure? Click yes to re-send the Approval Request Email to the next Approver.' ;
        }

        const options = {
                customUI: ({ onClose, ...props   }) =>
            <RequestDialog
        {...props}
        msg={message}
        onClose={onClose}
        onAccept={() => this.requestSign(onClose)}
        />

    };
        confirmAlert(options)
    }
    getRequest(status){
        const {project, approvalsResponse, situationText, timelineText,primaryContactText,outageCoordinatorText,approver} = this.state;
        let requestSignRequest = {};
        requestSignRequest.projectId = this.state.project.id;
        requestSignRequest.formId = this.props.match.params.formId;
        requestSignRequest.exceptionId = this.props.match.params.exceptionId;
        requestSignRequest.requesterUserId = approvalsResponse.loggedInUserId;
        requestSignRequest.statusId = status;
        requestSignRequest.project = project;
        requestSignRequest.roleId = approvalsResponse.nextApproveRoleId;
        return requestSignRequest;
    }

    async requestSign(onClose){
        spinnerOn();
        this.hideButtonGroup();
        let response = await requestApprover(this.getRequest(1));
        spinnerOff();
        this.unhideButtonGroup();
        if (response && (response.status == 'FAILURE' || response.status == 'WARNING')){
            this.showWarning(response.errorMessage);
            return;
        }
        onClose();
        this.getApproversList();
    }

    async restartSign(exceptionId,onClose){
        spinnerOn();
        this.hideButtonGroup();
        let response = await restartApprovalProcess(exceptionId);
        spinnerOff();
        this.unhideButtonGroup();
        if (response && (response.status == 'FAILURE' || response.status == 'WARNING')){
            this.showWarning(response.errorMessage);
            return;
        }
        onClose();
        this.getApproversList();
    }

    openApproveDialog(){
        let message = 'Are you sure? Click yes to approve the Exception and route to the next approver to complete the approval process.';
        const options = {
            customUI: ({ onClose, ...props }) =>
                <ApproveDialog
                    {...props}
                    msg={message}
                    onClose={onClose}
                    onAccept={() => this.approveRequest(onClose)}
                />
        };
        confirmAlert(options)
    }
    async approveRequest(onClose){
        spinnerOn();
        this.hideButtonGroup();
        let response = await approverProcess(this.getRequest(preApprovalStatusCodeMap['APPROVED']));
        spinnerOff();
        this.unhideButtonGroup();
        if (response && (response.status == 'FAILURE' || response.status == 'WARNING')){
            this.showWarning(response.errorMessage);
            return;
        }
        onClose();
        this.getApproversList();
    }
    openDenyDialog(){
        let message = 'Are you sure? Click yes to deny the Exception, stop Energization and end the Approval Workflow';
        const options = {
            customUI: ({ onClose, ...props  }) =>
                <DenyDialog
                    {...props}
                    msg={message}
                    onClose={onClose}
                    onAccept={() => this.denyRequest(onClose)}
                />
        };
        confirmAlert(options)
    }
    async denyRequest(onClose){
        spinnerOn();
        this.hideButtonGroup();
        let response = await approverProcess(this.getRequest(preApprovalStatusCodeMap['DENIED']));
        spinnerOff();
        this.unhideButtonGroup();
        if (response && (response.status == 'FAILURE' || response.status == 'WARNING')){
            this.showWarning(response.errorMessage);
            return;
        }
        onClose();
        this.getApproversList();
    }

    openCancelDialog(){
        let message ='Are you sure? Click yes to Cancel the Exception, meaning it is no longer necessary.';
        const options = {
                customUI: ({ onClose, ...props   }) =>
            <CancelDialog
        {...props}
        msg ={message}
        onClose={onClose}
        onAccept={() => this.cancelRequest(onClose)}
        />

    };
        confirmAlert(options)
    }
    async cancelRequest(onClose){
        spinnerOn();;
        this.hideButtonGroup();
        let response = await cancelApprover(this.getRequest(preExceptionStatusCodeMap['CANCELLED']));
        spinnerOff();
        this.unhideButtonGroup();
        if (response && (response.status == 'FAILURE' || response.status == 'WARNING')){
            this.showWarning(response.errorMessage);
            return;
        }
        onClose();
        this.getApproversList();
    }

    showWarning = (errorMessage) => {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Alert msg={errorMessage} onClose={onClose}/>
            );
            }
        });
        this.getApproversList();
    }

    showApprovalFlowDiagram()
    {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <img src={workflowdiagram} alt="workflow-diagram"
                         width="auto" height="auto"/>
                );
            }
        });
    }

    hideButtonGroup () {
        //document.getElementById('acceptButton').classList.add('disabledbutton');
        //document.getElementById('denyButton').classList.add('disabledbutton');
        //document.getElementById('cancelButton').classList.add('disabledbutton');
        //document.getElementById('requestButton').classList.add('disabledbutton');
        //document.getElementById('restartButton').classList.add('disabledbutton');
    }

    unhideButtonGroup () {
        //document.getElementById('acceptButton').classList.remove('disabledbutton');
        //document.getElementById('denyButton').classList.remove('disabledbutton');
        //document.getElementById('cancelButton').classList.remove('disabledbutton');
        //document.getElementById('requestButton').classList.remove('disabledbutton');
        //document.getElementById('restartButton').classList.remove('disabledbutton');
    }

}
export default withRouter(PreEApprovals);
